import { useEffect } from 'react';
import Toggle from '../../Components/Toggle/Toggle';
import PlusIcon from "../../Assets/PlusIcon/Add.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import Categories from './Components/Categories/Categories';
import CustomCollections from './Components/CustomCollections/CustomCollections';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategories, fetchCustomCollections, setActiveSection } from '../../Features/collectionsSlice';
import { CustomCollectionContextProvider } from '../../Context/Collections/CustomCollectionContext';
import { CategoriesContextProvider } from '../../Context/Collections/CategoryContext';

function Collections() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const activeSection = useSelector((state) => state.collections.activeSection);
    const categories = useSelector((state) => state.collections.categories.categories);
    const customCollections = useSelector((state) => state.collections.customCollections.customCollections);

    const handleSectionSelect = (e) => {
        dispatch(setActiveSection(e.target.id));
    }

    const handleAddCategory = () => {
        navigate(`${location.pathname}/categories/add-category`);
    }

    const handleAddCustomCollection = () => {
        navigate(`${location.pathname}/custom-collections/add-custom-collection`);
    }

    useEffect(() => {
        dispatch(fetchCategories());
        dispatch(fetchCustomCollections());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="size-full overflow-y-scroll pb-16 outline-none">
            <div className="flex items-center justify-between gap-6 m-[20px_19px_24px_20px]">
                <h1 className="text-[#121212] font-bold text-2xl select-none">Collections</h1>
            </div>

            <div className='flex items-center justify-between gap-3 mt-4 mx-5'>
                <Toggle 
                    items={{
                        firstItem: 'Categories',
                        secondItem: 'Custom Collections',
                        firstItemID: 'categories',
                        secondItemID: 'custom-collection', 
                        activeList: activeSection
                    }} 
                    onClick={handleSectionSelect} 
                />

                {
                    activeSection === 'categories' && 
                    (
                        categories.length !== 0 && 
                        <button onClick={handleAddCategory} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>
                            <div className="size-6 flex items-center justify-center">
                                <img src={PlusIcon} alt="" />
                            </div>

                            Add Category
                        </button>
                    )
                }

                {
                    activeSection === 'custom-collection' && 
                    (
                        customCollections.length !== 0 && 
                        <button onClick={handleAddCustomCollection} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>
                            <div className="size-6 flex items-center justify-center">
                                <img src={PlusIcon} alt="" />
                            </div>

                            Add Custom Collection
                        </button>
                    )
                }
            </div>

            {
                activeSection === 'categories' && 
                <CategoriesContextProvider>
                    <Categories />
                </CategoriesContextProvider>
            }

            {
                activeSection === 'custom-collection' && 
                <CustomCollectionContextProvider>
                    <CustomCollections />
                </CustomCollectionContextProvider>
            }
        </div>
    );
}

export default Collections;
